export default "__VITE_ASSET__CimO1$ji__"